var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.25C15.7279 21.25 18.75 17.7806 18.75 13.552C18.75 9.33137 16.125 4.9849 10.5 2.75C13.625 8.46141 12 11.5654 10.25 11.5654C8.5 11.5654 8.125 9.33053 9.5 7.2198C7.75 7.2198 5.25 10.0755 5.25 13.552C5.25 17.7735 8.27208 21.25 12 21.25ZM12 21.25C14.0711 21.25 15 19.4643 15 18.3929C15 16.4204 13.125 14.4643 12 13.75C10.875 14.4643 9 16.4204 9 18.3929C9 19.4643 9.92894 21.25 12 21.25Z",
    stroke: "#191E1B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.3ba84be7e3e5df181189b7fadaa12ca2.svg";
export { ForwardRef as ReactComponent };